"use strict";

exports.__esModule = true;
exports.tagManagerIsTealium = exports.tagManagerIsGtm = void 0;

const tagManagerIsTealium = whoami => {
  return whoami.tagManager.type === 'Tealium';
};

exports.tagManagerIsTealium = tagManagerIsTealium;

const tagManagerIsGtm = whoami => {
  return whoami.tagManager.type === 'Gtm';
};

exports.tagManagerIsGtm = tagManagerIsGtm;